<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    name: { required: true },
    selected: { default: false }
  },

  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    this.isActive = this.selected;
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Tab.vue?6f7e4a3c